export default {
  common: {
    days: 'jours',
    months: 'mois',
    required: 'requis',
    myScope: 'Mon Secteur',
    myIssue: 'Mes signalements',
    other: 'Autre',
    save: 'Enregistrer',
    pending: 'En cours',
    waiting: 'En attente',
    placeLoading: 'Chargement des adresses',
    auditLoading: 'Chargement des audits',
    auditReloading: 'Rechargement des audits',
    placeLoadingCaption: 'Vous pouvez déjà travailler en attendant...',
    placeLoaded: 'Chargement des adresses terminé',
    placeloadingError: 'Erreur lors du chargement des adresses',
    placeloadingErrorCaption: 'Nous allons réessayer plus tard',
    placeAbsent: 'Place introuvable',
    historyLoading: 'Chargement en cours ...',
    historyLoadingPercentage: 'Chargement en cours: {percentage}%',
    suggestions: 'Suggestions',
    allMonths: [
      'Jan',
      'Fev',
      'Mar',
      'Avr',
      'Mai',
      'Jun',
      'Jul',
      'Aou',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ],
    search: 'Rechercher',
    error: {
      NoNetwork:
        'Impossible de joindre le serveur, veuillez vérifier votre accès à internet',
      unmanagedError: "Une erreur non gérée s'est produite",
      unproceseableError: "Une erreur s'est produite pendant l'enregistrement",
      SessionExpired: 'Votre session a expiré, merci de vous reconnecter',
      unknownError: "Une erreur s'est produite",
      unknownErrorLastAction:
        "Une erreur s'est produite lors de la dernière action",
      completeAllInformation: 'Merci de compléter les champs en rouge',
      serverError: 'Impossible de joindre le serveur',
      ResetError:
        'Une erreur est survenue, veuillez vous reconnecter en cochant la case réinitialiser. Si le problème persiste, veuillez contacter votre responsable',
      suppressErrors: '{message} sur: {idIssues}',
      throwJsonApiErrors: '{message} détail \r\n {idIssues}'
    },
    true: 'Oui',
    false: 'Non',
    user: 'Utilisateur',
    done: 'Réalisé',
    late: 'En retard',
    details: 'Détails',
    close: 'fermer',
    searchWarning: 'La recherche nécessite au minimum 3 caractères',
    searchError: 'Aucun signalement ne correspond à votre recherche',
    send: 'Envoyer',
    audit: 'Contrôle',
    issue: 'Signalement',
    cancel: 'Annuler',
    pageNotFound: 'Page introuvable',
    noControlPending: 'Aucun contrôle en attente',
    thisWeek: 'cette semaine',
    loading: 'Chargement en cours',
    addRecipient: 'Ajouter un destinataire',
    status: 'Statut',
    complaintNumber: 'Numéro de réclamation',
    messaging: 'Messagerie',
    waitPlease: "Patientez s'il vous plaît.",
    downloading: 'Téléchargement en cours',
    agency: 'Agence',
    sendAlert: 'Envoyer une alerte',
    emailAddress: 'Adresse email',
    sendInfoToDev:
      "Des informations de débogage seront envoyées à l'équipe technique.",
    sendInfoToTeam:
      "Informations additionnelles que vous voulez transmettre à l'équipe concernant le problème rencontré (optionnel):",
    helper: {
      statusTranslation: {
        pending: 'En attente',
        ongoing: 'En cours',
        done: 'Traité',
        rejected: 'Rejeté'
      },
      statusTaskTranslation: {
        pending: 'Envoi en attente',
        ongoing: 'Envoi en cours',
        failed: 'Envoi rejeté'
      },
      translatePush: {
        UserConnected: {
          message: 'Bienvenue :',
          detail: 'Vous êtes maintenant connecté sur SoWell'
        },
        IssueCreated: {
          message: 'Nouvelle demande :',
          detail: "La demande #{id} vient d'être créée"
        },
        IssueUpdated: {
          message: 'Mise à jour :',
          detail: "La demande #{id} vient d'être mise à jour"
        },
        IssueTalkCreated: {
          message: 'Nouveau message :',
          detail:
            "Un nouveau message vient d'être enregistré sur la demande #{id}"
        },
        default: {
          message: 'Notification :'
        }
      }
    },
    hasPendingTaskDialog: {
      title: 'Déconnexion',
      message:
        "Il y a des signalements ou contrôles en cours d'envoi ! Ces signalements ou contrôles seront perdus si vous vous déconnectez maintenant.",
      ok: 'Voir la Liste',
      cancel: 'Se Déconnecter'
    },
    at: 'à',
    optional: 'optionnel',
    archive: 'Archiver',
    wrote: 'a écrit',
    reload: 'Recharger'
  },
  failedRequest: {
    title: 'Remonter un problème',
    information:
      "Un email contenant des informations de débogage sera envoyé à l'adresse email suivante:"
  },
  sync: {
    elements: 'éléments',
    send: "d'envoi",
    retrySend: "Relancer l'envoi",
    finish: 'Toutes les tâches ont été synchronisées',
    exitPage: 'vous pouvez quitter la page',
    sendIssueError:
      "Vous n'arrivez pas à envoyer les signalements ou contrôles après plusieurs tentatives?",
    contactDevelopers: 'Signaler le problème aux développeurs en cliquant ici',
    sendingTalk: "En cours d'envoi talks",
    sendingClose: 'En cours de fermeture',
    elementPending: "éléments en attente d'envoi",
    elementToSend: "éléments {taskStatus} d'envoi",
    pending: 'en cours',
    waiting: 'en attente',
    show: 'Afficher',
    ongoingTracking: 'Création en cours...',
    sendingCode: 'Edition du numéro de réclamation'
  },
  login: {
    connectWithMicrosoft: 'Me connecter avec Microsoft',
    description: "Veuillez saisir vos identifiants d'accès",
    password: 'Mot de passe',
    email: 'Email',
    logIn: 'Connexion',
    loginFailed: "L'email ou le mot de passe est incorrect.",
    connectErrors: 'Merci de saisir vos identifiants',
    forgottenPassword: 'Mot de passe oublié',
    tapEmail: 'Veuillez entrer votre email',
    passwordUpdated: 'Votre Mot de passe a été modifié',
    pageExpired: 'Le lien que vous avez suivi a expiré',
    fillPassword: 'Veuillez saisir un nouveau mot de passe.',
    errorPasswordEmpty: 'Merci de saisir votre nouveau mot de passe',
    fillWithSamePassword: 'Merci de saisir le même mot de passe',
    errorSamePasswordValidation:
      'Les mots de passe saisis ne correspondent pas',
    newPassword: 'Nouveau mot de passe',
    newPasswordConfirmation:
      'Merci de saisir votre nouveau mot de passe deux fois',
    goBack: 'Retour',
    img: 'photo',
    mailSent:
      'Vous recevrez un lien de récupération de mot de passe dans votre boîte email dans quelques minutes',
    mailNotSent: "Votre Adresse Email n'est pas dans notre base",
    or: 'Ou',
    errorValidationEmail: 'Merci de saisir une adresse email valide',
    errorValidationPassword: 'Merci de saisir votre mot de passe',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    accountMigratedToV2:
      "Connexion impossible : cette version de l'application a été désactivée suite à la mise à jour vers SoWell +",
    resetPasswordTitle: 'Réinitialisation de votre mot de passe',
    resetPasswordSubtitle: 'Veuillez configurer un nouveau mot de passe',
    passwordPlaceholder: 'Minimum 8 caractères',
    confirmPasswordPlaceholder: 'Répéter le mot de passe',
    passwordRequirementMinLength: '8 caractères minimum',
    passwordRequirementUppercase: '1 majuscule',
    passwordRequirementLowercase: '1 minuscule',
    passwordRequirementDigit: '1 chiffre',
    passwordRequirementLetter: '1 lettre',
    passwordRequirementSpecialChar: '1 Caractère spécial',
    saveNewPassword: 'Enregistrer mon nouveau mot de passe',
    passwordInvalidFormat:
      'Le mot de passe saisi ne respecte pas le format requis. Veuillez vérifier les critères ci-dessus.',
    passwordSequenceError:
      'Le mot de passe ne doit pas contenir de séquence simple de 4 caractères ou plus (ex. 1234, abcd, azerty, qwerty).',
    passwordSaved: 'Mot de passe enregistré !',
    passwordSavedSubtitle:
      "Vous pouvez maintenant accéder à l'intégralité de vos services SoWell.",
    connectMe: 'Me connecter',
    serverError: 'Erreur technique, veuillez contacter votre administrateur.',
    // Flux magiclink (1ère connexion / mot de passe oublié)
    firstConnectionQuestion: "C'est votre première connexion ?",
    activateAccount: 'Activer mon compte',
    firstConnectionTitle: 'Connexion',
    firstConnectionDescription:
      'Saisissez votre adresse e-mail professionnelle pour recevoir les instructions de paramétrage.',
    forgotPasswordTitle: 'Mot de passe oublié',
    forgotPasswordDescription:
      'Saisissez votre adresse e-mail professionnelle pour recevoir les instructions de réinitialisation.',
    emailPlaceholder: "exemple{'@'}gmail.com",
    continueButton: 'Continuer',
    channelTitle: 'Canal de réception',
    channelSubtitle:
      'Choisissez comment vous souhaitez recevoir votre lien de connexion sécurisé.',
    channelEmailLabel: 'Par Email',
    channelSmsLabel: 'Par SMS',
    channelSmsDescription: 'Par SMS',
    channelExpiryWarning:
      'Le lien expirera dans 30 minutes pour garantir la sécurité de votre compte.',
    sendMagicLink: 'Envoyer le lien',
    magicLinkSentTitle: 'Lien envoyé !',
    magicLinkSentDescription:
      'Le lien vous a bien été envoyé. Cliquez dessus pour paramétrer votre mot de passe.',
    magicLinkCheckInboxMessage:
      'Vérifiez votre boîte de réception et cliquez sur le lien pour accéder à votre compte.',
    magicLinkCheckSmsMessage:
      'Vérifiez vos SMS et cliquez sur le lien pour accéder à votre compte.',
    openMailbox: 'Ouvrir ma boîte mail',
    resendMagicLink: 'Renvoyer le lien',
    resendMagicLinkCountdown: 'Renvoyer le lien ({seconds}s)',
    magicLinkWarning:
      "Si vous ne voyez pas l'e-mail dans quelques minutes, vérifiez votre dossier de courriers indésirables (spam).",
    backToFirstLogin: 'Retour à la 1ère connexion',
    magicLinkForbiddenTitle: 'Réinitialisation impossible',
    magicLinkForbiddenMessage:
      'Votre compte utilise la connexion Microsoft. La gestion de votre mot de passe est effectuée par Microsoft. Pour le modifier, rendez-vous sur votre compte Microsoft ou contactez votre administrateur.',
    setPasswordTitle: 'Paramétrage de votre mot de passe',
    setPasswordDescription:
      'Pour accéder à votre compte, vous devez définir votre mot de passe par défaut.',
    magicLinkPasswordChangedSubtitle:
      "Votre compte est désormais sécurisé. Vous pouvez maintenant accéder à l'intégralité de vos services SoWell.",
    errorMagicLinkAccountNotFound:
      'Aucun compte ne correspond ou une erreur est survenue',
    errorMagicLinkExpired:
      'Ce lien a expiré ou a déjà été utilisé. Veuillez recommencer.',
    errorUnprocessableRequest:
      "Votre demande n'a pas pu être traitée. Veuillez réessayer ou contacter le support.",
    // L'API V1 renvoie des messages en anglais : on ne les affiche jamais, on
    // retombe sur ce libellé quand le code d'erreur n'est pas reconnu.
    errorMagicLinkGeneric:
      'Une erreur est survenue. Veuillez réessayer ou contacter le support.'
  },
  navigation: {
    issue: 'Signalements',
    toCreateIssue: 'Signaler',
    toCreateReport: 'Contrôler',
    history: 'Historique',
    audits: 'Contrôles',
    archivedReports: 'Rapports archivés'
  },
  notification: {
    title: 'Notification',
    shortTitle: 'Notif',
    issue: `La demande # {issue} a changé de statut`,
    default: 'Information de SoWell',
    appUpdate:
      'Une mise à jour est disponible, elle sera installée automatiquement',
    appUpdateError:
      'Une mise à jour est disponible mais ne peut être installée',
    appUpdateWarning:
      "Une mise à jour a été installée, l'application SoWell va redémarrer ...",
    permissiondenied: 'Les notifications locales ont été désactivées',
    talk: {
      title: 'Nouveau message',
      message: `La demande #{issue} a un nouveau message`,
      ok: 'Voir',
      cancel: 'Plus tard'
    },
    issueCreated: {
      title: 'Nouveau message',
      message: "La demande #{issue} vient d'être ajoutée sur votre secteur",
      ok: 'Voir',
      cancel: 'Plus tard'
    },
    categories: {
      alertError: {
        title: "Erreur d'envoi",
        message: "Suite à un problème réseau, votre alerte n'a pas été envoyée."
      },
      alertWithoutPosition: {
        title: 'Alerte envoyée sans localisation',
        message:
          "Votre position n'a pas pu être déterminée. Indiquez où vous vous trouvez.",
        label: 'Où vous trouvez-vous ?'
      },
      initAlertDetails: {
        cancel: 'Annuler'
      }
    },
    scheduleNotification: {
      title: "Des éléments sont en attente d'envoi",
      body: "Veuillez ouvrir l'application SoWell dans un endroit avec une bonne connexion internet"
    }
  },
  createIssue: {
    private: "je m'en charge",
    requestTenant: 'A la demande du locataire',
    request: 'Demande',
    tenant: 'Locataire',
    priorityLow: 'Basse',
    priorityNormal: 'Normale',
    priorityhigh: 'Élevé',
    rgpd: 'info RGPD',
    rgpdInfo: 'Information RGPD',
    rgpdInfoDetails: {
      personalData:
        'Conformément à la réglementation sur la protection des données personnelles',
      accessComment:
        'les locataires peuvent accéder aux commentaires sur simple demande.',
      dpo: 'Il est rappelé que les informations collectées doivent être objectives, adéquates, pertinentes et non excessives au regard de la finalité poursuivie. Pour en savoir plus sur l’utilisation des zones de commentaires libres, contactez votre DPO'
    },
    noSpotOnselectedPlace:
      'Aucune adresse disponible sur la catégorie et la résidence concernée',
    openGallery: 'Ouvrir la galerie',
    takePicture: 'Prendre une photo',
    addPicture: 'Ajouter une photo',
    agencyEmpty: "Aucune agence n'est selectionnée",
    residenceEmpty:
      "Aucune résidence n'existe sur cette agence, veuillez contacter votre service technique",
    placeEmpty:
      "Aucune adresse n'existe sur cette residence, veuillez contacter votre service technique",
    spotEmpty:
      "Aucune localisation n'existe sur cette adresse, veuillez contacter votre service technique",
    sendIssueError: "Une erreur s'est produite, veuillez réessayer plus tard",
    unprocessableError:
      'Un signalement similaire a été créé il y a moins de 24h',
    error: 'Impossible de créer ce signalement',
    dismissLabel: 'Annuler'
  },
  issueDetails: {
    sendMessageTo: 'Envoyer un message à',
    detailsOfIssue: 'Signalement',
    details: 'Détails',
    importance: 'Priorité',
    reportAndCheckpointInfo: 'Audit',
    residence: 'Résidence',
    place: 'Adresse',
    author: 'Auteur',
    message: 'Détails',
    spot: 'Localisation',
    sendingTalk: 'Envoi en cours',
    createdAt: 'Date de création',
    me: 'Moi',
    type: 'Type',
    send: 'Envoyer',
    chat: 'Messagerie',
    on: 'Le',
    by: 'par',
    at: 'à',
    issueDate: 'Date du signalement',
    fileDownloadSucced: 'Fichier téléchargé avec succès',
    fileDownloadFailed: 'Impossible de télécharger le fichier',
    images: 'Photos',
    forwardIssuesMessage: "Envoyer à l'ERP",
    externalIssuesUrl: 'Lien vers le signalement',
    forwardIssuesSuccess: 'Nouveau signalement transmis avec succès',
    forwardIssuesFailed:
      'Le transfert du nouveau signalement a échoué, une erreur est survenue',
    reason: 'Motif',
    isPrivate: "Je m'en charge",
    sending: 'Envoi Signalement N°',
    close: 'Cloturer',
    closePermissionError:
      "Vous n'avez pas les droits suffisant pour cloturer ce signalement",
    closeError: "Une erreur s'est produite lors de la cloture du signalement",
    codePermissionError:
      "Vous n'avez pas les droits suffisant pour la mis a jour du signalement",
    codeError:
      "Une erreur s'est produite lors de la mise à jour du code du signalement",
    duplicateError:
      "Le signalement n'est pas cloturer parce qu'il est déjà en cours",
    unknownError:
      "Une erreur inconnue s'est produite. Veuillez contacter votre administrateur",
    sendByEmail: {
      title: 'Envoyer par email',
      recipients: 'Emails des destinataires',
      body: 'Votre message',
      recipientsWrong: 'Adresse e-mail invalide',
      sendSuccess: 'Email envoyé',
      sendFailed: "Erreur lors de l'envoi de l'email"
    },
    sendSuccess: 'Signalement transmis avec succès',
    sendError: 'Le transfert du signalement a échoué, une erreur est survenue',
    noIssueToShow: 'Aucun signalement à afficher pour le moment',
    specifyIssue: 'Préciser le signalement',
    accessForbidden:
      "Vous n'avez pas les droits suffisant pour cloturer ce signalement"
  },
  report: {
    ko: 'Anomalie',
    accuracy: 'Précisions',
    excludedCheckpoint: 'Contrôle impossible',
    excludedCheckpointWarning:
      "Vous venez d'indiquer que l'élément à contrôler n'existe pas. Cette question sera supprimée après validation",
    comment: {
      label: 'Commentaire (optionnel) ',
      placeholder: 'Votre Commentaire ici...'
    },
    before_date: 'Au plus tard le',
    housing: 'Logement',
    sendReportError: "Une erreur s'est produite veuillez résssayez",
    missingSpotError: "Veuillez sélectionner un emplacement avant d'archiver",
    lockedMessage:
      "Ce contrôle a déjà été archivé. L'envoi au serveur se fera automatiquement.",
    reloadAuditError: "Une erreur s'est produite veuillez résssayez",
    reloadAuditMessage:
      "Une erreur s'est produite lors de la récupération des audits"
  },
  audit: {
    loadingAudit: 'Chargement des contrôles',
    auditFinish: 'Plus de contrôle en attente,',
    goodJob: 'bon boulot !'
  },
  createReport: {
    unprocessableError: 'Ce contrôle a déjà été réalisé il y a moins de 24h'
  },
  createTalk: {
    error: "Impossible d'envoyer votre message"
  },
  sendAlert: {
    error: "Impossible denvoyer la demande d'assistance"
  }
}
